import { render, staticRenderFns } from "./VGrid.vue?vue&type=template&id=8d3a56ca&scoped=true&"
import script from "./VGrid.vue?vue&type=script&lang=ts&"
export * from "./VGrid.vue?vue&type=script&lang=ts&"
import style0 from "./VGrid.vue?vue&type=style&index=0&id=8d3a56ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3a56ca",
  null
  
)

export default component.exports